import PropTypes from 'prop-types';
import { SecondaryButton } from 'jl-design-system/elements/button/Button';

import styles from './ScreenNav.scss';

export const PreviousButton = ({ text = 'Previous', ...props }) => (
  <SecondaryButton inline className={styles.NavButton} {...props}>
    {text}
  </SecondaryButton>
);

PreviousButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
};
